import cs from "classnames";

import type {
  AutocompleteBaseProps,
  AutocompleteRenderInputParams,
} from "@braintrust/braintrust-ui-components";
import {
  AutocompleteBase,
  Box,
  Loader,
  RegularTextField,
} from "@braintrust/braintrust-ui-components";

import styles from "./styles.module.scss";

type InvitationsAutocompleteProps<
  ValueType,
  Multiple extends boolean,
> = DistributiveOmit<
  AutocompleteBaseProps<ValueType, Multiple, true, false>,
  "renderInput"
> & {
  inputSlotProps?: Partial<AutocompleteRenderInputParams["slotProps"]["input"]>;
  placeholder: string;
};

export const InvitationsAutocomplete = <ValueType, Multiple extends boolean>({
  className,
  inputSlotProps,
  placeholder,
  ...props
}: InvitationsAutocompleteProps<ValueType, Multiple>) => {
  return (
    <AutocompleteBase
      renderValue={() => null}
      loadingText={
        <Box sx={{ p: 3, position: "relative" }}>
          <Loader centered />
        </Box>
      }
      className={cs(styles.autocomplete, className)}
      popupIcon={null}
      disableClearable
      selectOnFocus
      clearOnBlur
      handleHomeEndKeys
      renderInput={(params) => {
        return (
          <RegularTextField
            {...params}
            className={styles.autocompleteInput}
            placeholder={placeholder}
            slotProps={{
              ...params.slotProps,
              input: { ...params.slotProps.input, ...inputSlotProps },
            }}
          />
        );
      }}
      {...props}
      slotProps={{
        paper: {
          className: styles.listBox,
        },
      }}
    />
  );
};
